export default "__VITE_ASSET__DuV7XPQP__"